import { RPGTypes } from '@ps/poker-games-tile-mappers';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'universal-cookie';

import { ResolverTag } from '@swf/core/enums';
import useRequest from '@swf/core/hooks/useRequest';
import useResolver from '@swf/core/hooks/useResolver';
import { select } from '@swf/core/store';
import Cookie from '@swf/core/types/Cookies';
import { useGetCurrentDate } from '@swf/poker';

import { EncodedWebEndpointType } from '../components/PokerGameTile/PokerGameTile';

interface Props {
  type: string;
  serverAddress: string;
  serverObjectName: string;
  newTab?: boolean;
  onClose?: unknown;
}

export const getType = (type: Props['type']) =>
  type === RPGTypes.CASH_GAME || type === RPGTypes.SAG
    ? EncodedWebEndpointType.TABLE_STATIC_DATA
    : EncodedWebEndpointType.TOURNAMENT_STATIC_DATA;

const cookies = new Cookies();

const useEncodedEndpoint = ({ type, serverAddress, serverObjectName, newTab, onClose }: Props) => {
  const [url, setUrl] = useState<string>('');
  const resolver = useResolver(ResolverTag.WebPoker);
  const request = useRequest();
  const brand = useSelector(select.site.getBrand);
  const site = useSelector(select.site.getId);
  const { timeZone } = useGetCurrentDate();
  const { token, signature, userWebId } = useSelector(select.session.get);
  const country = useSelector(select.account.getCountry);

  useEffect(() => {
    if (!resolver) {
      return;
    }
    request({
      service: 'homeGames.encodedWebEndpointRequest',
      body: { serverAddress, serverObjectName, type: getType(type) }
    }).subscribe(({ body: { encodedWebEndpoint } }) => {
      const wbUrl = `${resolver}/?standalonetable=true&debug=true&args=${window.btoa(
        JSON.stringify({
          endpoint: encodedWebEndpoint,
          gametype: type.toLowerCase(),
          sbtk: token,
          sbsg: signature,
          wbid: userWebId,
          site,
          brand,
          xiid: cookies.get(Cookie.INSTALL_ID),
          country,
          origin: window.location.origin,
          timezone: timeZone
        })
      )}`;
      setUrl(wbUrl);

      if (newTab) {
        window.open(wbUrl, '_blank');
        typeof onClose === 'function' && onClose();
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolver]);

  return { url };
};

export default useEncodedEndpoint;
